import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Typography from "@mui/material/Typography";
import Creatable from 'react-select/creatable';
import {

    showErrorSnackbar,
  } from "store/actions/snackbarMessage";
  import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
    root: {},
    progess: {
      position: "absolute",
    },
    table: {},
    qtyCell: {
      width: 10,
    },
    content: {
      height: 250,
    },
  }));
  

const TimesheetDeleteDialog = (props) => {
  const { open, deleteProxy, close, updateReason, reason } = props;
  
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isbuttonDisabled, setIsButtonDisabled] = useState(true);
  
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const showErrorMessage = (msg) => dispatch(showErrorSnackbar(msg));

  const reasons = ["Wrong transaction", "Refund", "Testing"];

  const handleClose = () => {
    close()
  };

  const handleDeleteTran = () => {
  
    deleteProxy();
    close()
  };

  const checkButtonDisabled = () => {
      console.log('checkButtonDisabled', reason);
        if (reason.length === 0) {
          setIsButtonDisabled(true);
          return;
        } 
        setIsButtonDisabled(false);
        
  };



  const handleChange = (newValue, actionMeta) => {
      
      if (newValue) {
        updateReason(newValue.value);
      } else {
       updateReason('');
      }
      checkButtonDisabled();
  };

  const handleInputChange = (inputValue, actionMeta) => {
    
      if (inputValue) {
        updateReason(inputValue);
      } else {
       // updateReason('');
      }
      checkButtonDisabled();
  };

  return (
    <div>
      <Dialog
       fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"You are about to delete transactions!"}
        </DialogTitle>
        <DialogContent className={classes.content}>
          <DialogContentText>

            <Typography>
                Please select or enter a reason to delete.
                </Typography> 
            <Creatable
              labelId="demo-simple-select-filled-label"
              id="deleteReason"
              isClearable
              onChange={handleChange}
              onInputChange={handleInputChange}
              
              options={reasons.map(reason => ({value:reason, label: reason}))}
            />
          
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button  color="primary" onClick={handleDeleteTran} disabled={isbuttonDisabled}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TimesheetDeleteDialog;
